export default {
  SET_RESPONSE_COLLECTION_ID: 'SET_RESPONSE_COLLECTION_ID',
  SET_AUTH: 'SET_USER_AUTH',
  SET_INFO: 'SET_USER_INFO',
  CLEAR: 'CLEAR_USER',
  SIGNIN: 'SIGNIN',
  SIGNUP: 'SIGNUP',
  LOGOUT: 'LOGOUT',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  REMOVE_ACCOUNT: 'REMOVE_ACCOUNT',
};
